<template>
  <div class="more-info-right">
    <div class="carousel-col" v-observe-visibility="visibilityChanged">
      <div class="row">
        <div class="col col-12" v-if="$route.name !== 'payment'">
          <button
            class="btn btn-primary text-uppercase"
            @click="book"
          >{{ currency }}{{ parseFloat(moreInfo.price).toFixed(2) }} {{ $t('more_info.book_now') }}</button>
        </div>
      </div>
      <carousel 
        :perPage="1" 
        :navigationEnabled="true" 
        :paginationEnabled="false" 
        class="lounge-slider carousel"
        v-if="visible">
        
        <slide v-for="index in 4" :key="index">
          <div class="carousel-item active">
            <img
              :src="`https://skyparkupload1.s3-eu-west-1.amazonaws.com/products/airportlounge/${moreInfo.product_id}/${moreInfo.product_id}_${index}.jpg`"
              :alt="`${moreInfo.product_name}-${index}`" 
            />
          </div>
        </slide>
      </carousel>
    </div>
  </div>
</template>

<script>
import { sync } from "vuex-pathify";
import { eventBus } from "@/eventBus";
import mixins from "@/mixins";
import { Carousel, Slide } from 'vue-carousel';

export default {
  name: "LoungeRightCol",
  mixins: [mixins.format, mixins.globals],
  components: { Slide, Carousel },
  computed: {
    moreInfo: sync("modals/moreInfo")
  },
  data() {
    return {
      visible: false,
    }
  },  
  methods: {
    book() {
      eventBus.$emit("SELECTED", this.moreInfo);
    },
    visibilityChanged() {
      this.visible = false;
      this.$nextTick(() => {
        this.visible = true;
      })
    }
  }
};
</script>